import React from 'react';
import './OrderItem.css';
import { money } from '../../../helper/Utility';

const OrderItem = ({ item }) => {
  return (
    <div className="ItemContainer">
      <div style={{ margin: "0.5rem", display: 'flex' }}>
        <img src={item.image} className="cardImg" />
        <div className="ItemQuantity">
          <p className={"ItemQuantityText"}>{item.quantity}</p>
        </div>
      </div>
      <p className="ItemText">{money(item.price)}</p>
    </div>
  )
};

export default OrderItem;